@if (buttonVisible() && enabled()) {
<button
    mat-stroked-button
    id="form-nav-btn-pdf"
    class="form-nav-btn-pdf"
    title="Save and Print PDF"
    (click)="saveAndPrint()"
    [disabled]="saving() || generating()">
    @if (saving() || generating()) {
        <mat-spinner diameter="20"></mat-spinner>
    }
    @else {
        <mat-icon [svgIcon]="'mat_outline:print'"></mat-icon>
    }
    <span class="nav-menu-hidden-text">{{ buttonText() }}</span>
</button>

<!--
<button type="button" class="btn-iapply btn-block-lg btn iapply-docgen-print" title="Download the application PDF" style="display:none;"
    ng-hide="!saveAndPrintEnabled || preview || submits || pageType === 'receipt' || applicationEntitlement.BaseAccess !== 'W' || !isOnline || !prevPage"
    ng-click="saveAndPrintApplication()">
    <i class="fa fa-print"></i> Print
    <span calculation-spinner="" class="three-quarter-spinner" ng-class="{ 'is-busy': generatingInProgress }"></span>
</button>
-->
}
